import { render, staticRenderFns } from "./wxGuide.vue?vue&type=template&id=68cd21dc&scoped=true&"
import script from "./wxGuide.vue?vue&type=script&lang=js&"
export * from "./wxGuide.vue?vue&type=script&lang=js&"
import style0 from "./wxGuide.vue?vue&type=style&index=0&id=68cd21dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cd21dc",
  null
  
)

export default component.exports